<!--
 * @Author: zl
 * @Date: 2022-04-14 09:27:48
 * @LastEditTime: 2022-08-23 08:36:32
 * @LastEditors: zl
 * @Description: 规划图
-->
<template>
	<div class="planMap-layout filter-layout">
		<div class="filter-box primary-header">
			<div class="planMap-header">
				<el-tabs v-model="activeName"
						 @tab-click="tabClick">
					<el-tab-pane label="规划图"
								 name="1"></el-tab-pane>
					<el-tab-pane label="历史记录"
								 name="2"></el-tab-pane>
				</el-tabs>
				<transition name="fade"
							mode="out-in">
					<el-button type="primary"
							   size="small"
							   @click="uploadFile"
							   v-if="!isMaintenance && activeName == '1'">上 传</el-button>
				</transition>
			</div>
			<transition name="fade"
						mode="out-in">
				<el-form ref="searchForm"
						 :model="searchForm"
						 label-width="100px"
						 size="small"
						 v-if="activeName == '2'">
					<el-col :span="6">
						<el-form-item label="上传人"
									  prop="createUser">
							<el-input v-model="searchForm.createUser"
									  placeholder="请输入上传人"
									  clearable></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="上传单位"
									  prop="upUnit">
							<el-select v-model="searchForm.upUnit"
									   placeholder="请选择上传单位"
									   clearable>
								<el-option v-for="item in upUnitList"
										   :key="item.id"
										   :label="item.shortName"
										   :value="item.id"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="上传时间"
									  prop="time">
							<el-date-picker v-model="searchForm.time"
											type="daterange"
											format="yyyy-MM-dd"
											value-format="yyyy-MM-dd HH:ss:mm"
											:default-time="['00:00:00', '23:59:59']"
											start-placeholder="开始时间"
											end-placeholder="结束时间"
											range-separator="-"
											clearable
											@change="timeChange"></el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item class="text-right">
							<el-button type="primary"
									   icon="el-icon-search"
									   @click="searchFormResult">查询</el-button>
							<el-button icon="el-icon-refresh"
									   @click="refreshForm">刷新</el-button>
						</el-form-item>
					</el-col>
				</el-form>
			</transition>
		</div>
		<div class="filter-content ">
			<transition name="fade"
						mode="out-in">
				<template v-if="activeName == '1'">
					<template v-if="tableObj.table.length > 0">
						<iframe :src="previewUrl"
								frameborder="0"
								width="100%"
								height="100%"></iframe>
					</template>
				</template>
				<template v-if="activeName == '2'">
					<div class="w-table-layout w-table-page">
						<div class="w-table-content">
							<vxe-table align="center"
									   auto-resize
									   ref="planTable"
									   border
									   :data="tableObj.table"
									   key="1"
									   height="100%"
									   highlight-current-row
									   highlight-hover-row
									   :loading="tableObj.loading"
									   show-overflow="tooltip"
									   show-header-overflow="tooltip">
								<vxe-column title="序号"
											width="70"
											type="seq"></vxe-column>
								<vxe-column title="资料名称"
											field="fileName"
											header-align="center"
											align="left"
											min-width="400">
									<template #default="{ row }">
										<div style="width:95%">
											<FileName class="vxe-cell--label"
													  :fileName="row.fileName"
													  :filePath="row.filePath"
													  :fileSize="row.fileSize"></FileName>
										</div>
									</template>
								</vxe-column>
								<vxe-column title="文件编制单位"
											field="redactUnit"></vxe-column>
								<vxe-column title="上传人"
											field="createUser"></vxe-column>
								<vxe-column title="上传单位"
											field="upUnit">
									<template #default="{ row }">
										<el-tooltip effect="dark"
													:content="row.upUnit"
													placement="top">
											<span class="vxe-cell--label">{{ row.shortName }}</span>
										</el-tooltip>
									</template>
								</vxe-column>
								<vxe-column title="上传时间"
											field="createDate"></vxe-column>
							</vxe-table>
						</div>
						<div class="w-table-pager">
							<vxe-pager :current-page="tableObj.currentPage"
									   :page-size="tableObj.pageSize"
									   :total="tableObj.total"
									   :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
									   align="center"
									   @page-change="handleCurrentChange"></vxe-pager>
						</div>
					</div>
				</template>
			</transition>
		</div>

		<!-- 上传弹窗 -->
		<el-dialog title="添加资料"
				   :visible.sync="dialogShow"
				   width="1200px"
				   center
				   :close-on-click-modal="false"
				   :destroy-on-close="true"
				   @close="doCancel">
			<p class="mb10"
			   v-if="dialogType == 'add'">请将需要上传的文件在此窗口一次性操作完毕，窗口关闭后之前上传的文件将会被覆盖</p>
			<myUpload list-type="table"
					  ref="fileUpload"
					  :createUser="userInfo.sname"
					  :createCompany="upUnit"
					  :shortName="shortName"
					  tableName="plan_map"
					  assortment="plan_map_file"
					  :aid="currentId"
					  :isDisabled="dialogType == 'view'"
					  :mode="dialogType"
					  :noDelete="true"
					  uploadType="0"></myUpload>
			<div slot="footer"
				 class="custom-dialog-footer">
				<el-button class="btn"
						   @click="doCancel">取 消</el-button>
				<el-button class="btn"
						   type="primary"
						   @click="doSubmit">保 存</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import { getTreeTableList } from 'api/system/sysTenant'
import * as API from 'api/projectManage/ProjectIndex'
import * as MapAPI from 'api/PlanMap/PlanMap'
import FileName from '@/components/file/fileName'
import VUE_CONFIG from '../../../vue.config.js'
import { previewUrl } from '../../utils/tools'
export default {
	name: 'PlanMap',
	components: { FileName },
	data() {
		return {
			activeName: '1', //激活的tab
			searchForm: {
				time: [],
				startTime: '', //上传开始时间
				endTime: '', //上传结束时间
				createUser: '', //上传人
				upUnit: '', // 上传单位
			},
			tableObj: {
				table: [], //列表数据
				pageSize: 10, //条数
				currentPage: 1, //页码
				total: 0, //总条数
				loading: false, //加载
				pageList: [10, 20, 50, 100], // 显示条数数组
			},
			dialogShow: false, //弹窗显隐
			dialogType: '', //弹窗类别
			currentId: '0', //当前操作id
			upUnit: '', //上传单位全称
			shortName: '', //上传单位简称
			previewUrl: '', //预览路径
			upUnitList: [], //上传单位
		}
	},
	created() {
		// 获取当前登录人公司信息
		this.getCompanyMsg()
		// 获取附件列表
		this.getFileList()
		// 上传单位
		this.getTableList()
	},
	methods: {
		// 时间change事件
		timeChange(data) {
			this.searchForm.startTime = data?.[0] ?? ''
			this.searchForm.endTime = data?.[1] ?? ''
		},

		// 获取当前登录人公司信息
		getCompanyMsg() {
			API.selectTenantInformation({
				tenantId: this.$getSessionItem('tenantId'),
			}).then((res) => {
				if (res.data !== null) {
					this.upUnit = res.data.unitName
					this.shortName = res.data.shortName
				}
			})
		},

		// 获取上传单位
		getTableList() {
			getTreeTableList({}).then((res) => {
				this.upUnitList = res.data
			})
		},

		// 获取附件列表
		getFileList() {
			this.tableObj.loading = true
			let params = this.$utils.clone(this.searchForm, true)
			params.current = this.tableObj.currentPage
			params.size = this.tableObj.pageSize
			delete params.time
			MapAPI.selectPlanMap(params)
				.then((res) => {
					this.tableObj.loading = false
					this.tableObj.table = res.data.records
					this.tableObj.total = parseInt(res.data.total)
					if (res.data.records.length > 0) {
						let uploadUrl = ''
						if (process.env.VUE_APP_UPLOAD_URL == '/uploadApi') {
							uploadUrl =
								VUE_CONFIG.devServer.proxy['/uploadApi'].target
						} else {
							uploadUrl = process.env.VUE_APP_UPLOAD_URL
						}
						this.previewUrl =
							this.$previewUrl + previewUrl(uploadUrl + res.data.records[0].filePath)
					}
				})
				.catch(() => {
					this.tableObj.loading = false
				})
		},

		// 分页处理
		handleCurrentChange({ currentPage, pageSize }) {
			this.tableObj.currentPage = currentPage
			this.tableObj.pageSize = pageSize
			this.getFileList()
		},

		// tab点击事件
		tabClick(data) {
			if (data.name == '2') {
				this.searchFormResult()
			}
		},

		// 刷新按钮
		searchFormResult() {
			this.tableObj.currentPage = 1
			this.getFileList()
		},

		// 重置按钮
		refreshForm() {
			this.searchForm.startTime = ''
			this.searchForm.endTime = ''
			this.$refs.searchForm.resetFields()
			this.searchFormResult()
		},

		// 上传按钮
		uploadFile() {
			this.dialogShow = true
			this.dialogType = 'add'
		},

		// 取消按钮点击事件
		doCancel() {
			this.dialogShow = false
			this.dialogType = ''
			this.currentId = '0'
			this.getFileList()
		},

		// 取消按钮点击事件
		doSubmit() {
			this.$refs.fileUpload.fileSend(
				this.currentId,
				'10000000012',
				() => {
					this.$message.success('上传成功！')
					this.doCancel()
				},
				() => {
					this.doCancel()
				}
			)
		},
	},
	computed: {
		...mapState('app', {
			projectInfo: (state) => state.projectInfo,
		}),
		...mapState('user', {
			userInfo: (state) => state.userInfo,
			// 运维角色
			isMaintenance: (state) => state.isMaintenance,
		}),
	},
}
</script>
<style lang='less' scoped>
.planMap-layout {
	height: 100%;
	.filter-box {
		border: none;
	}
	.planMap-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
}
.btn {
	padding: 0 50px !important;
}
</style>